import {
    faBowlFood,
    faDroplet,
    faFaceGrin,
    faListCheck,
    faSuitcaseMedical,
    faToilet,
    faZzz
} from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface TaskTypeOption {
    id: string;
    label: string;
    icon: IconDefinition;
    color: string;
    taskType?: number;
    disabled?: boolean;
}

export const TASK_TYPE_OPTIONS: Array<TaskTypeOption> = [
    {
        id: 'feeding',
        label: 'Feeding',
        icon: faBowlFood,
        color: '#BAA997',
        taskType: 1
    },
    {
        id: 'medication',
        label: 'Medication',
        icon: faSuitcaseMedical,
        color: '#EF4F57',
        taskType: 2
    },
    {
        id: 'hydration',
        label: 'Hydration',
        icon: faDroplet,
        color: '#5B8DB8',
        taskType: 3
    },
    {
        id: 'relief',
        label: 'Relief',
        icon: faToilet,
        color: '#8B6B4A',
        taskType: 4
    },
    {
        id: 'enrichment',
        label: 'Enrichment',
        icon: faFaceGrin,
        color: '#AC7A40',
        disabled: true
    },
    {
        id: 'rest',
        label: 'Rest',
        icon: faZzz,
        color: '#7B6BAD',
        disabled: true
    },
    {
        id: 'other',
        label: 'Other',
        icon: faListCheck,
        color: '#9CA3AF',
        disabled: true
    }
];

export const TASK_TYPE_LABEL_MAP: Record<string, string> = Object.fromEntries(
    TASK_TYPE_OPTIONS.map(t => [t.id, t.label])
);

export const TASK_TYPE_NUMBER_MAP: Record<string, number | undefined> = Object.fromEntries(
    TASK_TYPE_OPTIONS.map(t => [t.id, t.taskType])
);
